import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { get } from 'lodash';
import { BellIcon } from '@heroicons/react/24/outline';

const GenericNotification = ({ notification }) => {
  const intl = useIntl();
  const action = get(notification, 'action', 'Unknown notification');
  
  return (
    <div className="flex items-start space-x-3">
      {/* Icon */}
      <div className="flex-shrink-0">
        <div className="w-10 h-10 bg-succession-primary-10 rounded-full flex items-center justify-center">
          <BellIcon className="w-5 h-5 text-succession-primary" />
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="text-sm">
          <span className="font-medium text-succession-text-primary">{intl.formatMessage({ id: 'succession.notifications.generic.title' })}</span>
        </div>
        
        <div className="mt-1 text-sm text-succession-text-secondary">
          {action}
        </div>
      </div>
    </div>
  );
};

GenericNotification.propTypes = {
  notification: PropTypes.shape({
    action: PropTypes.string,
  }).isRequired,
};

export default GenericNotification; 